<template>
<div>
    <Navigation />
        <v-container class="mt-1 mb-10">
            <Secretary v-if="role === 'Secretary'" />
            <ServiceProvider v-if="role === 'Psychologist' || role === 'Counselor' || role === 'Psychiatrist'" />
            <User v-if="role === 'User'" />
        </v-container>
    <v-footer class="primary darken-4" absolute>
        <v-spacer></v-spacer>
        <div class="inline-flex text-center">
            <span class="white--text">This booking system is co-designed and developed by #MentalHealthPH, Inc. volunteers (c) 2022 </span>
        </div>
        <v-spacer></v-spacer>
    </v-footer>
    <v-snackbar v-model="inActivity" :timeout="timeout" bottom>
        Logging out due to inactivity
    </v-snackbar>
</div>
</template>

<script>
// @ is an Navigation to /src
import Navigation from '../components/Navigation'
import Secretary from '../components/Secretary'
import ServiceProvider from '../components/ServiceProvider'
import User from '../components/User'
import store from '../store'

export default {
    name: 'Home',
    components: {
        Secretary,
        ServiceProvider,
        Navigation,
        User
    },
    data() {
        return {
            role: '',
            timeout: 2000,
            inActivity: false

        }
    },
    onIdle() {
        this.inActivity = true
        setTimeout(() => {
            this.$store.dispatch('logout').then(() => this.$router.push('/login'))
        }, this.timeout)

    },
    mounted() {
        this.role = store.getters.getUserRole
    }
}
</script>
